import React from 'react';
import { Form } from '../ui-kit';
import styled from 'styled-components';
import SkillIcon from '../general/SkillIcon';
import DutyFunctionIcon from '../general/DutyFunctionIcon';
import ContractStatisticsProgress from '../contracts/ContractStatisticsProgress';
import ContractConstraintIndicator from '../contracts/ContractConstraintIndicator';
import AvailabilityIcon from './AvailabilityIcon';
import round from '../../utils/round';

const TdWrapper = styled.div`
  max-width: 200px;
  min-width: 200px;
`;
const TdWrapperSmall = styled.div`
  max-width: 150px;
  min-width: 150px;
`;

const TdWrapperBalance = styled.div`
  max-width: 70px;
  min-width: 70px;
`;

const balance = value => {
  // value sometimes is a string, we need to parse them into numbers first
  const roundedValue = round(value, 2);

  if (value > 0) {
    return `+${roundedValue}`;
  }

  return roundedValue;
};

const CandidatesSelectTableRow = props => (
  <tr>
    <td>
      <TdWrapperSmall>
        <Form.Check
          value={props.candidate.user.id}
          id={`schedule_exchanges_${props.requestType}_candidate_user${props.candidate.user.id}`}
          name={`schedule_exchanges_${props.requestType}[candidate_user_ids][]`}
          onChange={props.onChange}
          checked={props.selectedCandidates.includes(props.candidate.user.id)}
          label={`${props.candidate.user.first_name} ${props.candidate.user.last_name}`}
        />
      </TdWrapperSmall>
    </td>
    <td>
      <TdWrapper>
        {(props.candidate.skills || []).map(
          skill =>
            props.skills[skill] && (
              <React.Fragment key={skill}>
                <SkillIcon skill={props.skills[skill]} />{' '}
              </React.Fragment>
            )
        )}
      </TdWrapper>
    </td>
    <td>
      <TdWrapperSmall>
        {props.candidate.groups
          .filter(g => g.type === 'station')
          .map(group => (
            <span key={group.id}>
              <AvailabilityIcon candidate={props.candidate} group={group} />
              &nbsp;
              {group.name}
              <br />
            </span>
          ))}
      </TdWrapperSmall>
    </td>
    <td>
      <TdWrapper>
        {props.candidate.availability_codes.map(
          ac => props.availabilityCodes[ac] && <SkillIcon skill={props.availabilityCodes[ac]} key={ac} />
        )}{' '}
        {props.candidate.assigned_functions.map(df => (
          <DutyFunctionIcon key={df} dutyFunction={props.dutyFunctions[df]} />
        ))}
        {props.candidate.availability_codes.length > 0 && props.candidate.comments.length > 0 && <br />}
        {props.candidate.comments.length > 0 && <small>{props.candidate.comments}</small>}
      </TdWrapper>
    </td>
    <td>
      <ContractStatisticsProgress contractStatistics={props.candidate.contractStatistics} />
    </td>
    <td className="number-column">
      <TdWrapperBalance>
        {props.candidate.contractStatistics && props.candidate.contractStatistics.balance
          ? balance(props.candidate.contractStatistics.balance)
          : null}
      </TdWrapperBalance>
    </td>
    <td className="contract-constraints">
      <ContractConstraintIndicator contractStatistics={props.candidate.contractStatistics} />
    </td>
  </tr>
);

export default CandidatesSelectTableRow;
